import logo from 'assets/header-prevencor-xx.png';
import md5 from 'md5';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import fetchImageBase64 from 'utils/helpers';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Função para gerar PDF do Prontuário Eletrônico
export async function generatePdfProntuario({ prontuario }) {
  // headerBase64: imagem do cabeçalho (base64) opcional
  const logoBase64 = await fetchImageBase64(logo);
  const safeProntuario = prontuario || {};
  const docDefinition = {
    pageMargins: [40, 30, 30, 50],
    content: [
      logoBase64 && {
        image: logoBase64,
        width: 550,
        alignment: 'center',
        margin: [0, 0, 0, 16],
      },
      {
        text: 'PRONTUÁRIO ELETRÔNICO',
        style: 'header',
        alignment: 'center',
        margin: [0, 0, 0, 18],
        color: '#1976d2',
        decoration: 'underline',
      },
      {
        text: `Paciente: ${prontuario?.NOMEPAC || ''}`,
        style: 'subheader',
        margin: [0, 0, 0, 2],
        color: '#333',
      },
      { text: `CPF: ${prontuario?.CPFPAC || ''}`, margin: [0, 0, 0, 2] },
      {
        text: `Data de Nascimento: ${prontuario?.dataNasc || ''}`,
        margin: [0, 0, 0, 2],
      },
      {
        text: `Médico Responsável: ${prontuario?.NOMEMED || ''}`,
        margin: [0, 0, 0, 2],
      },
      { text: `CRM: ${prontuario?.CRMMED || ''}`, margin: [0, 0, 0, 2] },
      {
        text: `Data do Atendimento: ${prontuario?.dataFormatada || ''}`,
        margin: [0, 0, 0, 10],
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515 - 80,
            y2: 0,
            lineWidth: 1,
            lineColor: '#e3f2fd',
          },
        ],
        margin: [0, 6, 0, 10],
      },
      { text: `Queixa Principal E História`, style: 'sectionTitle' },
      { text: prontuario?.QUEIXAS || '-', style: 'sectionContent' },
      { text: `Medicações em Uso`, style: 'sectionTitle' },
      { text: prontuario?.MEDICAMENTOS || '-', style: 'sectionContent' },
      { text: `Hábitos`, style: 'sectionTitle' },
      { text: prontuario?.HABITOS || '-', style: 'sectionContent' },
      { text: `Antecedentes Pessoais/Familiares`, style: 'sectionTitle' },
      {
        text: prontuario?.ANTECEDENTES_PESSOAIS || '-',
        style: 'sectionContent',
      },
      { text: `Exames Complementares Prévio`, style: 'sectionTitle' },
      {
        text: prontuario?.EXAMES_COMPLEMENTARES || '-',
        style: 'sectionContent',
      },
      { text: `Exames Físicos`, style: 'sectionTitle' },
      { text: prontuario?.EXAME_FISICO || '-', style: 'sectionContent' },
      { text: `ECG`, style: 'sectionTitle' },
      { text: prontuario?.ISDA || '-', style: 'sectionContent' },
      { text: `Hipótese Diagnóstica`, style: 'sectionTitle' },
      {
        text: prontuario?.HIPOTESE_DIAGNOSTICA || '-',
        style: 'sectionContent',
      },
      { text: `Conduta`, style: 'sectionTitle' },
      { text: prontuario?.CONDUTA || '-', style: 'sectionContent' },
      { text: `Observações`, style: 'sectionTitle' },
      { text: prontuario?.OBS || '-', style: 'sectionContent' },
      { text: `CID1`, style: 'sectionTitle' },
      { text: prontuario?.CID || '-', style: 'sectionContent' },
      { text: `CID2`, style: 'sectionTitle' },
      { text: prontuario?.CID2 || '-', style: 'sectionContent' },
      { text: `CID3`, style: 'sectionTitle' },
      { text: prontuario?.CID3 || '-', style: 'sectionContent' },
      // Campo para assinatura do paciente
      { text: '', margin: [0, 30, 0, 2] },
      {
        canvas: [
          {
            type: 'line',
            x1: 120,
            y1: 0,
            x2: 420,
            y2: 0,
            lineWidth: 1.2,
            lineColor: '#333',
          },
        ],
        margin: [0, 0, 0, 2],
      },
      {
        text: 'Assinatura do paciente',
        alignment: 'center',
        margin: [0, 0, 0, 0],
        fontSize: 12,
        color: '#333',
      },
      {
        text: prontuario?.NOMEPAC || '',
        alignment: 'center',
        margin: [0, 0, 0, 0],
        fontSize: 12,
        color: '#333',
      },
      {
        text: `Data: ${new Date().toLocaleDateString('pt-BR')}    Hora: ${new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`,
        alignment: 'center',
        margin: [0, 4, 0, 0],
        fontSize: 11,
        color: '#555',

        alignment: 'center',
        margin: [0, 4, 0, 0],
        fontSize: 11,
        color: '#555',
      },
    ].filter(Boolean),
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        color: '#1976d2',
        decoration: 'underline',
      },
      subheader: { fontSize: 14, bold: true, color: '#333' },
      sectionTitle: {
        fontSize: 13,
        bold: true,
        color: '#1976d2',
        margin: [0, 10, 0, 2],
      },
      sectionContent: { fontSize: 11, color: '#222', margin: [0, 0, 0, 8] },
    },
    footer: (currentPage, pageCount) => ({
      margin: [20, 10, 20, 0],
      stack: [
        {
          text: 'Documento assinado eletronicamente',
          alignment: 'center',
          bold: true,
          margin: [0, 5, 0, 0],
          fontSize: 10,
          italics: true,
        },
        {
          text: `Autenticação: ${md5(JSON.stringify(safeProntuario))}`,
          bold: true,
          italics: true,
          alignment: 'center',
          margin: [0, 0, 0, 0],
        },
        {
          text: `Página ${currentPage} de ${pageCount}`,
          alignment: 'center',
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
      ],
      fontSize: 9,
    }),
    defaultStyle: { fontSize: 11 },
  };
  return new Promise((resolve) => {
    pdfMake.createPdf(docDefinition).getBlob((blob) => resolve(blob));
  });
}
